@if (!authStore.isInitialized()) {
    <nice-ops-splash />
} @else {
    <router-outlet />
}
